import { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import appSocketService, { MaintenancePayload } from '../services/AppSocketService';

/**
 * Globaler Wartungs-Banner. Wird per Socket-Event `maintenance` gesteuert
 * (vom Server-PromotionService gesendet).
 *
 * Aufgabenteilung:
 * - phase 'maintenance' (geplant, Countdown): läuft als Eintrag im
 *   Mitteilungs-Laufband des Dashboards (siehe Dashboard.tsx) – NICHT hier.
 * - phase 'switching':   "Wartung läuft" als globaler Alarm. Kein Auto-Reload –
 *   der Server-Ausfall während des Wechsels wird ohnehin clientseitig erkannt.
 * - active=false:        Banner wird einfach entfernt (keine "beendet"-Meldung)
 */
export default function MaintenanceBanner() {
  const [payload, setPayload] = useState<MaintenancePayload | null>(null);

  useEffect(() => {
    const handler = (data: MaintenancePayload) => {
      if (!data || data.active === false || data.phase === 'done' || data.phase === 'aborted' || data.phase === 'failed') {
        setPayload(null);
        return;
      }
      setPayload(data);
    };

    appSocketService.onMaintenance(handler);
    return () => appSocketService.offMaintenance(handler);
  }, []);

  if (!payload) return null;

  // Die geplante Wartung (Countdown) läuft im Dashboard-Mitteilungs-Laufband.
  // Hier wird nur noch der eigentliche Wechsel als globaler Alarm gemeldet.
  if (payload.phase !== 'switching') return null;

  return (
    <div
      role="alert"
      className="fixed inset-x-0 top-0 z-[9999] flex items-center justify-center gap-3 px-4 py-2.5 text-sm font-medium text-white shadow-lg bg-red-600"
    >
      <AlertTriangle className="h-5 w-5 shrink-0" />
      <span className="text-center">
        Wartung läuft – das System wird aktualisiert und ist gleich kurz nicht erreichbar.
      </span>
    </div>
  );
}
